<div
    class="flex"
    [class.flex-column]="!displayInline()">
    @for (option of options(); track option.value) {
        <div class="flex items-center mr-4">
            <p-radiobutton
                [name]="name()"
                [value]="option.value"
                [inputId]="optionInputId(option.value)"
                [disabled]="disabled()"
                [ngModel]="value()"
                (ngModelChange)="handleChange($event)"
                [ngModelOptions]="standaloneNgModel" />
            <label
                [for]="optionInputId(option.value)"
                class="ml-2 mb-0">
                {{ option.label }}
            </label>
        </div>
    }
</div>
